export default {
    data: [{
        key: 'ASSET_CLASSES',
        name: 'ASSET CLASSES',
        entries: 10,
    }, {
        key: 'COMPANIES',
        name: 'COMPANIES',
        entries: 10,
    }, {
        key: 'COUNTRIES',
        name: 'COUNTRIES',
        entries: 10,
    }, {
        key: 'FUND_STRATEGIES',
        name: 'FUND STRATEGIES',
        entries: 10,
    }, {
        key: 'GP_FIRM_STRATEGIES',
        name: 'GP FIRM STRATEGIES',
        entries: 10,
    }, {
        key: 'GP_STRATEGIES',
        name: 'GP STRATEGIES',
        entries: 10,
    }, {
        key: 'INDUSTRIES',
        name: 'INDUSTRIES',
        entries: 10,
    }, {
        key: 'INDUSTRY_GROUPS',
        name: 'INDUSTRY GROUPS',
        entries: 10,
    }, {
        key: 'INDUSTRY_SECTORS',
        name: 'INDUSTRY SECTORS',
        entries: 10,
    }, {
        key: 'REGIONS_A',
        name: 'REGIONS A',
        entries: 10,
    }, {
        key: 'REGIONS_B',
        name: 'REGIONS B',
        entries: 10,
    }],
}
